import React, {useState} from "react";
import {
    Button,
    Form,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import * as UserService from "../../api/UserService";
import Style from "../Style.module.css";
import AvailableStylesSelector from "../AvailableStylesSelector";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";

function EditGameModalWindow(props) {
    const [isManualDice, setIsManualDice] = useState(!props.isAutoDice)
    const [isAutoDice, setIsAutoDice] = useState(props.isAutoDice)
    const [newGameName, setNewGameName] = useState()
    const [newPlayerName, setNewPlayerName] = useState()
    const [isSaved, setIsSaved] = useState(false)
    const [selectedStyle, setSelectedStyle] = useState(props.selectedStyle)
    const [selectedDeck, setSelectedDeck] = useState(props.selectedDeck)
    const { t } = useTranslation('translation', { keyPrefix: 'editGameModal' });

    function ResolveAutoDice() {
        setIsAutoDice(true)
        setIsManualDice(false)
    }

    function ResolveManualDice() {
        setIsManualDice(true)
        setIsAutoDice(false)
    }

    function ResolveGameFieldStyle(event) {
        setSelectedStyle(event.target.value)
    }

    function ResolveSelectedDeck(event) {
        setSelectedDeck(event.target.value)
    }

    function storeNewGameName(event) {
        setNewGameName(event.target.value)
    }

    function storeNewPlayerName(event) {
        setNewPlayerName(event.target.value)
    }

    const renderVideoConnectionTooltip = (props) => (
        <Tooltip className="alternativeVideoTooltip" id="alternative-video-tooltip" {...props}>
            <div>{t('notEditable')}</div>
        </Tooltip>
    )

    function changeButton() {
        setIsSaved(true)
        trySetTimeout(() => {
            setIsSaved(false)
        }, 1500)
    }

    //TODO send request only id values were changes
    function postGameUpdate() {
        UserService.postUpdateGame(
            props.gameId,
            newPlayerName,
            isAutoDice,
            newGameName,
            selectedStyle,
            selectedDeck.split("-")[0],
            selectedDeck.split("-")[1],
            () => {
                props.updataGames()
                changeButton()
            },
            () => window.alert(t('errorMessage'))
        )
    }

    return (
        <Modal
            show={true}
            onHide={props.onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                <ModalTitle>{t('editGame')}</ModalTitle>
            </ModalHeader>
            <ModalBody style={{backgroundColor: "white"}}>
                <Form.Group className="mb-3">
                    <Form.Label>{t('gameName')}</Form.Label>
                    <Form.Control
                        defaultValue={props.gameName}
                        type="textarea"
                        autoFocus
                        onInput={e => storeNewGameName(e)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>{t('playerName')}</Form.Label>
                    <Form.Control
                        type="textarea"
                        defaultValue={props.playerName}
                        onInput={e => storeNewPlayerName(e)}
                    />
                </Form.Group>
                {!props.privateGame &&
                    <>
                        <Form>
                            <Form.Check
                                onChange={ResolveAutoDice}
                                checked={isAutoDice}
                                inline
                                type={'radio'}
                                label={t('autoDice')}
                            />
                            <Form.Check
                                onChange={ResolveManualDice}
                                checked={isManualDice}
                                inline
                                type={'radio'}
                                label={t('manualDice')}
                            />
                        </Form>
                        <br/>
                        <div style={{display: "grid", gridTemplateColumns: "120px 0.3fr 200px 0.3fr"}}>
                            <Form.Label className={Style.bodyBaseText}>{t('video')}</Form.Label>
                            <OverlayTrigger placement="top" delay={{show: 150, hide: 250}}
                                            overlay={renderVideoConnectionTooltip}>
                            <div>
                                <Form>
                                    <Form.Check
                                        style={{
                                            marginBottom: "24px",
                                        }}
                                        checked={props.videoAllowed}
                                        readOnly={true}
                                        id={"trial_game"}
                                        type="switch"
                                    />
                                </Form>
                            </div>
                            </OverlayTrigger>
                        </div>
                    </>
                }
                <AvailableStylesSelector
                    selectedStyle={selectedStyle}
                    setSelectedStyle={ResolveGameFieldStyle}
                    selectedDeck={selectedDeck}
                    setDefaultDeck={() => {}}
                    setSelectedDeck={ResolveSelectedDeck}/>
            </ModalBody>

            <ModalFooter>
                <Button variant="primary" onClick={props.onClose} style={{backgroundColor: "#7749F8"}}>
                    {t('closeButton')}
                </Button>
                <Button variant="primary" style={isSaved ? {backgroundColor: "green"} : {backgroundColor: "#7749F8"}}
                        onClick={postGameUpdate}>
                    {isSaved ? t('savedButton') : t('saveButton')}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default EditGameModalWindow